<template src="../templates/normal_fcont_98.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import CreatorProfileMaikaKokubo from '../components/CreatorProfileMaikaKokubo'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreativePrint,CreatorProfileMaikaKokubo,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['98-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['98-2']}
    ]};

  }
};
</script>
<style >

</style>

